export default __webpack_public_path__ + "static/media/SafeLogo.a6ce855d.png";